export default __webpack_public_path__ + "static/media/banner1.dfc50e11.jpg";